import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { COMMAND_PRIORITY_HIGH, KEY_ESCAPE_COMMAND } from 'lexical';

type Props = {
  onEsc?: () => void;
};

const KeyBoardPlugin: React.FC<Props> = ({ onEsc }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_ESCAPE_COMMAND,
      (payload) => {
        onEsc?.();
        return false;
      },
      COMMAND_PRIORITY_HIGH,
    );
  }, [editor]);

  return null;
};

export default KeyBoardPlugin;
